<template>
  <div>
    <div v-if="loadingStatus">
      <v-col cols="12" md="12" sm="12">
        <v-skeleton-loader
          :loading="loadingStatus"
          class="ma-2"
          type="card@6"
          elevation="2"
        >
        </v-skeleton-loader>
      </v-col>
    </div>

    <v-row v-else class="ma-2">
      <v-col
        cols="12"
        md="12"
        sm="12"
        v-for="team in nflTeamDepthChart.data"
        :key="team.TeamID"
      >
        <v-card outlined rounded elevation="1">
          <v-list-item>
            <v-list-item-avatar tile size="80">
              <v-img contain :src="team.WikipediaLogoUrl"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <div class="text-h6 ma-4">{{ team.City }} {{ team.Name }}</div>
            </v-list-item-content>
          </v-list-item>

          <!-- position wise palyer list -->
          <v-row class="pa-2" justify="center">
            <!-- QB -->
            <v-col md="2" cols="12" sm="3">
              <base-title-bar
                elevation="1"
                class="text-center"
                color="blue white--text"
                label="Quaterback"
              />
              <v-sheet elevation="0" rounded class="pa-2">
                <router-link
                  style="text-decoration: none; color: green; cursor: pointer"
                  class="text-center"
                  v-for="(qb, index) in team.QBplayer"
                  :key="index"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: qb.PlayerID, SportId: 4 },
                  }"
                >
                  <p>{{ index + 1 }}. {{ qb.Name }} ({{ qb.DepthOrder }})</p>
                </router-link>
              </v-sheet>
            </v-col>

            <!-- RB -->
            <v-col md="2" cols="12" sm="3">
              <base-title-bar
                elevation="1"
                class="text-center"
                color="blue white--text"
                label="Running Back"
              />
              <v-sheet elevation="0" rounded class="pa-2">
                <router-link
                  style="text-decoration: none; color: green; cursor: pointer"
                  class="text-center"
                  v-for="(rb, index) in team.RBplayer"
                  :key="index"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: rb.PlayerID, SportId: 4 },
                  }"
                >
                  <p>{{ index + 1 }}. {{ rb.Name }} ({{ rb.DepthOrder }})</p>
                </router-link>
              </v-sheet>
            </v-col>

            <!-- wr -->
            <v-col md="2" cols="12" sm="3">
              <base-title-bar
                elevation="1"
                class="text-center"
                color="blue white--text"
                label="Wide Receiver"
              />
              <v-sheet elevation="0" rounded class="pa-2">
                <router-link
                  style="text-decoration: none; color: green; cursor: pointer"
                  class="text-center"
                  v-for="(wr, index) in team.WRplayer"
                  :key="index"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: wr.PlayerID, SportId: 4 },
                  }"
                >
                  <p>{{ index + 1 }}. {{ wr.Name }} ({{ wr.DepthOrder }})</p>
                </router-link>
              </v-sheet>
            </v-col>

            <!-- TE -->
            <v-col md="2" cols="12" sm="3">
              <base-title-bar
                elevation="1"
                class="text-center"
                color="blue white--text"
                label="Tight End"
              />
              <v-sheet elevation="0" rounded class="pa-2">
                <router-link
                  style="text-decoration: none; color: green; cursor: pointer"
                  class="text-center"
                  v-for="(te, index) in team.TEplayer"
                  :key="index"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: te.PlayerID, SportId: 4 },
                  }"
                >
                  <p>{{ index + 1 }}. {{ te.Name }} ({{ te.DepthOrder }})</p>
                </router-link>
              </v-sheet>
            </v-col>

            <!-- K -->
            <v-col md="2" cols="12" sm="3">
              <base-title-bar
                elevation="1"
                class="text-center"
                color="blue white--text"
                label="Kicker"
              />
              <v-sheet elevation="0" rounded class="pa-2">
                <router-link
                  style="text-decoration: none; color: green; cursor: pointer"
                  class="text-center"
                  v-for="(k, index) in team.Kplayer"
                  :key="index"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: k.PlayerID, SportId: 4 },
                  }"
                >
                  <p>{{ index + 1 }}. {{ k.Name }} ({{ k.DepthOrder }})</p>
                </router-link>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "NflTeamDepth",

  created() {
    this.fetchTeamDepth();
  },

  computed: {
    ...mapState("NflModule", ["nflTeamDepthChart", "loadingStatus"]),
  },

  methods: {
    fetchTeamDepth() {
      this.$store.dispatch("NflModule/getTeamDepth");
    },
  },
};
</script>

<style></style>
